import React, { Component } from 'react';
import { withRouter, SessionStorage } from 'cw-styleguide-react';
import Utility from '../utility';
import { route } from '../routes';
import ResultsView from "../views/ResultsView";

class ResultsController extends Component {
  constructor(props) {
    super(props);

    this.state = {
      animal: null
    };
  }

  componentDidMount() {
    let code = '';
    const hasAnswers = this.props.answers.flat(1).some(answer => answer);

    // If has answers and therefore completed a quiz run.
    if (hasAnswers) {
      code = this.calculateCode(this.props.answers);

      // Save code to session storage for future reference.
      SessionStorage.set('buzzQuizLatestResult', code);
    }
    // Else has redirected straight to results and has not completed a quiz run.
    else {
      // Check if there is a code saved in session storage.
      SessionStorage.get('buzzQuizLatestResult', value => {
        code = value;
      }, () => {
        // Redirect to landing if no code saved in session storage.
        setTimeout(() => this.props.navigate(route('landing')));
      });
    }

    if (code) {
      const slug = Utility.lookupSlug(code);

      this.props.getAnimal(slug)
        .then(response => {
          this.setState({
            animal: response.data
          });
        });
    }
  }

  calculateCode(steps) {
    const letters = [];

    steps.forEach(answers => {
      answers.filter(answer => answer);

      const letter = Utility.mode(answers);

      letters.push(letter);
    });

    return letters.join('');
  }

  render() {
    return (
      <ResultsView
        {...this.props}
        {...this.state}
      />
    );
  }
}

export default withRouter(ResultsController);
